__turbopack_context__.v({
  "actif": "NavAdmin-module__wNJX9a__actif",
  "nav": "NavAdmin-module__wNJX9a__nav",
  "onglet": "NavAdmin-module__wNJX9a__onglet",
});
